/**
 * @generated SignedSource<<ba21defbb313cdee5def27751ff8c845>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FavoritesItemProvider_user$data = {
  readonly canShowFolder: boolean | null;
  readonly " $fragmentType": "FavoritesItemProvider_user";
};
export type FavoritesItemProvider_user$key = {
  readonly " $data"?: FavoritesItemProvider_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"FavoritesItemProvider_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FavoritesItemProvider_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canShowFolder",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7ae49ed70ebfeb6ba1187374b2f965c2";

export default node;
